'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UiLink = exports.styles = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = require('react-router-dom');

var _Typography = require('material-ui/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _styles = require('material-ui/styles');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = exports.styles = function styles(theme) {
  var _theme$palette$text = theme.palette.text,
      primary = _theme$palette$text.primary,
      secondary = _theme$palette$text.secondary;
  return {
    root: {},
    text: {
      display: "inline-block",
      color: primary,
      "&:hover": {
        color: secondary
      }
    }
  };
};

var UiLink = exports.UiLink = (_temp = _class = function (_Component) {
  _inherits(UiLink, _Component);

  function UiLink() {
    _classCallCheck(this, UiLink);

    return _possibleConstructorReturn(this, (UiLink.__proto__ || Object.getPrototypeOf(UiLink)).apply(this, arguments));
  }

  _createClass(UiLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          textClassName = _props.textClassName,
          classes = _props.classes,
          children = _props.children,
          color = _props.color,
          other = _objectWithoutProperties(_props, ['className', 'textClassName', 'classes', 'children', 'color']);

      return _react2.default.createElement(_reactRouterDom.Link, _extends({
        className: [classes.root, className].join(" ")
      }, other), _react2.default.createElement(_Typography2.default, {
        component: 'span',
        className: [classes.text, textClassName].join(" "),
        color: color
      }, children || ""));
    }
  }]);

  return UiLink;
}(_react.Component), _class.propTypes = {
  className: _propTypes2.default.string,
  textClassName: _propTypes2.default.string,
  color: _propTypes2.default.string
}, _class.defaultProps = {
  color: "inherit"
}, _temp);
exports.default = (0, _styles.withStyles)(styles)(function (props) {
  return _react2.default.createElement(UiLink, props);
}); // import React, { Component } from 'react'
// import PropTypes from 'prop-types'
// import {Link} from 'react-router-dom';
// export default class UiLink extends Component {
//   static propTypes = {
//     // prop: PropTypes
//   }
//   getUrl(){
//     return "javascript:;";
//   }
//   render() {
//     const {
//       ...other
//     } = this.props;
//     const url = this.getUrl();
//     return (
//       <Link
//         to={url}
//         href={url}
//         // activeClassName="fdgdgfd"
//         {...other}
//       />
//     )
//   }
// }